package org.zq.astrock_ai

import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview
import org.zq.astrock_ai.theme.BinanceTheme
import org.zq.astrock_ai.ui.StockPredictionScreen

@Composable
@Preview
fun App() {
    BinanceTheme {
        StockPredictionScreen()
    }
}
